export default function AutorizatiiPage() {

  const files = [
    "Demersuri autorizatie sanitara.PDF",
  ];

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-xl font-bold mt-8 mb-4">Autorizații</h2>
        <p>
            <b>Autorizația sanitară</b> a fost suspendată pe motivul schimbării denumirii 
            unității de învățământ, în prezent derulăm procedura pentru obținerea autorizației.
        </p>
        <p>
           Documente privind <b>securitatea la incendiu</b>: Liceul Tehnologic ”Dr. F. Ulmeanu” Ulmeni, Grădinița cu Program Prelungit Ulmeni și Școala Primară Mânău sunt  în curs de autorizare.
        </p>
        <p>
            Grădinița cu Program Normal Someș – Uileac nu face obiectul autorizării la incendiu .
        </p>

        {files.map((file) => (
          <p key={file}>
            <a
              href={`/documente/autorizatii/${file}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              📄 {file}
            </a>
          </p>
        ))}

      </main>
    </div>
  );
}